import { useSyncExternalStore } from "react";
import {
  isPositionsHighlightEnabled,
  setPositionsHighlightEnabled,
  subscribePositionsHighlight,
} from "src/util/positionsHighlightPref";

export const usePositionsHighlight = (): {
  highlightEnabled: boolean;
  setHighlightEnabled: (enabled: boolean) => void;
} => {
  const highlightEnabled = useSyncExternalStore(
    subscribePositionsHighlight,
    isPositionsHighlightEnabled,
    isPositionsHighlightEnabled
  );

  return {
    highlightEnabled,
    setHighlightEnabled: setPositionsHighlightEnabled,
  };
};

export default usePositionsHighlight;
